import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createBlock as _createBlock, renderList as _renderList, normalizeStyle as _normalizeStyle, Teleport as _Teleport } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = ["id"]
const _hoisted_3 = ["onClick"]

import { i18n } from '@/i18n';
import { onMounted, onUnmounted, ref, watch } from 'vue';
import SvgLoader from '@/utils/SvgLoader.vue';
import { SelectBoxNames } from './domains/entities/selectBoxNames';


export default /*@__PURE__*/_defineComponent({
  __name: 'SimpleSelectInput',
  props: {
    index: {},
    modelValue: {},
    propOptions: {},
    selectBoxName: {},
    customUnitValue: { default: undefined },
    displayAllow: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const t = i18n.t;

const props = __props;

const selected = ref<string>(props.modelValue);
const isOpen = ref(false);

const result = ref<DOMRect>();
const xLength = ref(0);
const yLength = ref(0);
const containerWidth = ref(0);

const emit = __emit;

watch(
  () => props.modelValue,
  () => {
    selected.value = props.modelValue;
  }
);

/**
 * ドロップダウンの表示状態を切り替えます。
 */
const toggleDropdown = () => {
  if (!props.disabled) {
    isOpen.value = !isOpen.value;
  }
  if (isOpen.value) {
    const element = document.getElementById(`${props.selectBoxName}-simple-select-container${props.index}`);
    if (!element) return;
    result.value = element.getBoundingClientRect();
    xLength.value = result.value.left;
    yLength.value = result.value.bottom;
    containerWidth.value = result.value.width;
  }
};

/**
 * オプションを選択し、親コンポーネントに選択値を通知します。
 * @param option - 選択されたオプション
 */
const selectOption = (option: string) => {
  selected.value = option;
  emit('update:modelValue', option);
  isOpen.value = false;
};

/**
 * ドロップダウンを閉じます。
 * @param event - クリックイベント
 */
const closeDropdown = (event: MouseEvent) => {
  if (!(event.target as Element).closest(`#${props.selectBoxName}-simple-select-${props.index}`)) {
    isOpen.value = false;
  }
};

onMounted(() => {
  document.addEventListener('click', closeDropdown);
});

onUnmounted(() => {
  document.removeEventListener('click', closeDropdown);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: `${props.selectBoxName}-simple-select-${_ctx.index}`,
    class: "simple-select-box"
  }, [
    _createElementVNode("div", {
      id: `${props.selectBoxName}-simple-select-container${_ctx.index}`,
      class: _normalizeClass(["simple-select-box__selected", { 'simple-select-box__selected--disabled': _ctx.disabled }]),
      onClick: toggleDropdown
    }, [
      _createElementVNode("span", {
        class: _normalizeClass(["simple-select-box__field", `simple-select-box__field--${selected.value}`])
      }, [
        (_ctx.customUnitValue === undefined)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(_unref(t)(selected.value)), 1)
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(_toDisplayString(_unref(t)(selected.value) + _unref(t)(_ctx.customUnitValue)), 1)
            ], 64))
      ], 2),
      (_ctx.displayAllow)
        ? (_openBlock(), _createBlock(SvgLoader, {
            key: 0,
            name: "arrowDown",
            class: "simple-select-box__arrow"
          }))
        : _createCommentVNode("", true)
    ], 10, _hoisted_2),
    (isOpen.value)
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 0,
          to: "body"
        }, [
          _createElementVNode("div", {
            class: "simple-select-box__dropdown",
            style: _normalizeStyle({
          top: `${yLength.value}px`,
          left: `${xLength.value}px`,
          width: `${containerWidth.value}px`,
        })
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.propOptions, (option) => {
              return (_openBlock(), _createElementBlock("div", {
                key: option,
                class: "simple-select-box__option",
                onClick: ($event: any) => (selectOption(option))
              }, [
                (_ctx.customUnitValue === undefined)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(_unref(t)(option)), 1)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(_unref(t)(option) + _unref(t)(_ctx.customUnitValue)), 1)
                    ], 64))
              ], 8, _hoisted_3))
            }), 128))
          ], 4)
        ]))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}
}

})